// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3gQH4","icon":"style_icon__1wjrS"};